module.exports = __webpack_public_path__ + "media/Instruction_61.076d1996.mp3";